// Преобразует одиннадцатисимвольную строку вида 11111111111
// в строку вида +1 (111) 11-11-11
export const formatPhone = (phone) => {
  if (phone.length !== 11) return phone;

  const numbers = phone.split('');

  return `+${numbers[0]} (${numbers
      .slice(1, 4)
      .join('')}) ${numbers.slice(4, 7).join('')}-${numbers
      .slice(7, 9)
      .join('')}-${numbers.slice(9, 11).join('')}`;
};

export const isMobile = () => {
  return /(ipad|iphone|android|mobile|touch)/i.test(navigator.userAgent)
}
